module.exports = __webpack_public_path__ + "static/media/build-collection-for-you-desktop.15091350.svg";